<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab key="CB1" @click="obtenerItemsC()">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - C
      </v-tab>
      <v-tab key="CB2" @click="obtenerItemsCR()">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - CR
      </v-tab>
      <!-- :disabled="accion===1" -->
      <!--Inicia tab Categoria C-->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes</v-col>
              <v-col cols="12" sm="12" md="6"> </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsC"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.idExpediente }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.noExpediente }}
                  </td>
                  <td>{{ item.nombreProyecto }}</td>
                  <!-- <td>
                    {{ item.descripcionProyecto }}
                  </td> -->
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadoRegistroId === 1
                          ? 'blue lighten-4'
                          : item.estadoRegistroId === 2
                          ? 'cyan lighten-4'
                          : item.estadoRegistroId === 3
                          ? 'amber'
                          : item.estadoRegistroId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadoRegistroId === 1
                          ? 'blue lighten-1'
                          : item.estadoRegistroId === 2
                          ? 'cyan darken-1'
                          : item.estadoRegistroId === 3
                          ? 'deep-orange darken-4'
                          : item.estadoRegistroId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                      <!-- <template
                        v-if="
                          item.estadoRegistroId !== 7 &&
                          item.estadoRegistroId !== 10 &&
                          item.estadoRegistroId !== 11
                        "
                      >
                      </template> -->
                    </v-chip>
                  </td>
                  <td>
                    <span v-if="item.tipoAprobacion !== null">
                      {{
                        item.tipoAprobacion === 6
                          ? "Aprobatoria"
                          : item.tipoAprobacion === 7
                          ? "No Aprobatoria"
                          : item.tipoAprobacion === 10
                          ? "Rechazada"
                          : "Estado desconocido"
                      }}
                    </span>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.idExpediente,
                          item.nombreProyecto,
                          item.estadoRegistroId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> Ver expediente
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadoExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="modalOpinionTecnica(item.id)"
                    >
                      <v-icon left>fas fa-file-alt</v-icon> Opinión Técnica
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadosExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        agregarDictamen(
                          item.id,
                          item.nombre_Proyecto,
                          item.tipoDictamen
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 && item.estadosExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="obtenerExpedienteDictamenes(item.id)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.estadosExpedienteId === 13 && item.resolucion > 0
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="enviarDirector(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Enviar a Director
                    </v-btn>
                    <v-btn
                      v-if="
                        item.dictamenCargado > 0 &&
                        (item.estadoRegistroId === 15 ||
                          item.estadoRegistroId === 20) &&
                        item.principal === 1
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerDictamenByExpediente(item.dictamenCargadoRuta)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon> Visualizar
                      Dictamen
                    </v-btn>
                    <v-btn
                      v-if="
                        (item.resolucionCargada > 0 &&
                          item.estadoRegistroId === 15) ||
                        item.estadoRegistroId === 30
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(
                          item.pathResolucionCargado
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        (item.estadoRegistroId === 17 || item.estadoRegistroId === 21) &&
                        item.noResolucion !== null
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.resolucionFirmada)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución Firmada
                    </v-btn>
                    <v-btn
                      v-if="
                        (item.resolucionCargada > 0 &&
                          item.estadoRegistroId === 15) ||
                        item.estadoRegistroId === 30
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="AbrirModalResolucion(item.idExpediente)"
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Firmar Resolución
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <!-- Categoría CR -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
              <v-col cols="12" sm="12" md="6"> </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsCR"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.idExpediente }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.noExpediente }}
                  </td>
                  <td>{{ item.nombreProyecto }}</td>
                  <!-- <td>
                    {{ item.descripcionProyecto }}
                  </td> -->
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-4'
                          : item.estadosExpedienteId === 2
                          ? 'cyan lighten-4'
                          : item.estadosExpedienteId === 3
                          ? 'amber'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-1'
                          : item.estadosExpedienteId === 2
                          ? 'cyan darken-1'
                          : item.estadosExpedienteId === 3
                          ? 'deep-orange darken-4'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                      <template
                        v-if="
                          item.estadosExpedienteId !== 7 &&
                          item.estadosExpedienteId !== 10 &&
                          item.estadosExpedienteId !== 11
                        "
                      >
                        <!-- {{
                          item.tipoDictamen === 1
                            ? "Aprobatoria"
                            : "No Aprobatoria"
                        }} -->
                      </template>
                    </v-chip>
                  </td>
                  <td>
                    <span v-if="item.tipoAprobacion !== null">
                      {{
                        item.tipoAprobacion === 6
                          ? "Aprobatoria"
                          : item.tipoAprobacion === 7
                          ? "No Aprobatoria"
                          : item.tipoAprobacion === 10
                          ? "Rechazada"
                          : "Estado desconocido"
                      }}
                    </span>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.idExpediente,
                          item.nombreProyecto,
                          item.estadoRegistroId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> Ver expediente
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadoExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="modalOpinionTecnica(item.id)"
                    >
                      <v-icon left>fas fa-file-alt</v-icon> Opinión Técnica
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadosExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        agregarDictamen(
                          item.id,
                          item.nombre_Proyecto,
                          item.tipoDictamen
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 && item.estadosExpedienteId === 13
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="obtenerExpedienteDictamenes(item.id)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.estadosExpedienteId === 13 && item.resolucion > 0
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="enviarDirector(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Enviar a Director
                    </v-btn>
                    <v-btn
                      v-if="
                        item.dictamenCargado > 0 &&
                        (item.estadoRegistroId === 15 ||
                          item.estadoRegistroId === 20) &&
                        item.principal === 1
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerDictamenByExpediente(item.dictamenCargadoRuta)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon> Visualizar
                      Dictamen
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        item.estadoRegistroId === 15
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(
                          item.pathResolucionCargado
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        (item.estadoRegistroId === 17 || item.estadoRegistroId === 21) &&
                        item.noResolucion !== null
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.resolucionFirmada)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución Firmada
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        item.estadoRegistroId === 15
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="AbrirModalResolucion(item.idExpediente)"
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Firmar Resolución
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-dialog
      v-model="dialogPinFirma"
      width="600"
      transition="scroll-y-transition"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5">
          Firmar Resolución

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCreaDictamen"
            @click="dialogPinFirma = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="d-none"></v-divider>
        <v-card-text>
          <v-col cols="12" md="12" sm="12" xs="12">
            <v-form
              ref="form"
              v-on:submit.prevent="firmaElectronica(1)"
              v-model="validForm"
            >
              <v-text-field
                v-model="datosItem.pin"
                class="required"
                dense
                filled
                label="Escriba su PIN"
                :rules="[required('PIN proporcionado por Cámara de Comercio')]"
                :type="showPin ? 'text' : 'password'"
                :append-icon="showPin ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPin = !showPin"
              >
              </v-text-field>
              <v-btn
                color="primary"
                class="mb-2 ml-2 float-right"
                type="submit"
                :elevation="0"
                :disabled="!validForm"
                :loading="btnRegistroLoading"
              >
                Firmar Resolución
              </v-btn>
            </v-form>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogPinFirma = false"
            :disabled="btnCreaDictamen"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-dialog
        v-model="dialogFirmaExpediente"
        width="600"
        transition="scroll-y-transition"
        persistent
      >
        <v-card>
          <v-card-title class="text-h5">
            Firma del Expediente

            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="dialogFirmaExpediente = false"
              class="float-right"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row class="mt-2">
              <v-col cols="12">
                <h3>¿Está seguro de firmar eel siguiente expediente?</h3>
                {{ proyectoSeleccionado }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="blue-grey darken-2"
              text
              @click="dialogFirmaExpediente = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="blue-grey darken-2"
              text
              @click="firmarExpediente(21)"
              :loading="btnEnvioAnalisis"
            >
              Sí, firmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar la firma del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(15)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <!--begin:: crear dictamen -->
    <v-dialog
      v-model="dialogCrearDictamen"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Crear Dictamen

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCreaDictamen"
            @click="dialogCrearDictamen = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea crear la resolución del siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogCrearDictamen = false"
            :disabled="btnCreaDictamen"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="registrarItemDictamen"
            :loading="btnCreaDictamen"
          >
            Sí, crear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <!--begin:: dialog envío expediente -->
    <!-- <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar el análisis del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(13)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogSolicitud"
      width="800"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Solicitud Vista Pública

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSolicitud = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fecha de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.fecha
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fotocopia Dpi</v-list-item-title
                  >
                  <v-btn
                    small
                    block
                    class="blue--text lighten-2--text text-capitalize"
                    color="blue lighten-5"
                    @click="descargarArchivo(solicitud.path)"
                  >
                    <v-icon left>mdi-file-download-outline</v-icon>
                    Descargar
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Expediente</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Expediente
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Proyecto</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre_Proyecto
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Dpi del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.dpi
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >No. de Teléfono del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Telefono
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Correo del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Motivo de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.motivo
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="red--text"
            dark
            color="red lighten-4"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 2)"
          >
            <v-icon left>fas fa-user-times</v-icon>Rechazar
          </v-btn>
          <!--:disabled="!validDocForm" type="submit"-->
          <v-btn
            class="green--text"
            dark
            color="teal lighten-5"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 1)"
          >
            <v-icon left> fas fa-user-check</v-icon>Aprobar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: modal registro-->
    <v-dialog
      v-model="dialogDictamen"
      max-width="1200"
      transition="scroll-y-transition"
      persistent
      scrollable
    >
      <v-card tile>
        <v-card-title>
          Resolución

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDictamen = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="d-none"></v-divider>

        <v-card-text class="pl-8 pr-8 pt-5">
          <v-form
            ref="form"
            v-on:submit.prevent="registrarItemDictamen"
            v-model="validFormDictamen"
          >
            <v-row>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-data-table
                  class="elevation-0"
                  :headers="headerDictamen"
                  :items="itemsDictamen"
                  :loading="tableDictamenLoading"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text': 'Registros por página',
                    pageText: '{0}-{1} de {2}',
                  }"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.fecha_Creacion }}</td>
                      <td>{{ item.usuario_Creacion }}</td>
                      <td>
                        <v-btn
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivoBackend(item.pathDictamen)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          v-if="item.tipoAprobacion === 1"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarPlantillaWord(item.expedienteId, 1)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar Aprobatoria
                        </v-btn>
                        <v-btn
                          v-if="item.tipoAprobacion === 2"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarPlantillaWord(item.expedienteId, 2)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar No Aprobatorio
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="
                            mostrarModalCargaDocumento(
                              item.id,
                              item.nombrePlantilla,
                              item.tipoAprobacion
                            )
                          "
                        >
                          <v-icon left>mdi-cloud-upload</v-icon> Cargar
                          Documento
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          v-if="item.pathPdf"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivoBackend(item.pathPdf)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <!--begin:: dialog carga de documento -->
    <v-dialog
      v-model="dialogCargaDocumento"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Cargar Resolución

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCargaDocLoading"
            @click="dialogCargaDocumento = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="formDoc"
            v-on:submit.prevent="cargarArchivo"
            v-model="validFormDocumento"
          >
            <v-row>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <v-subheader class="text-h6 text-uppercase">
                  {{ documentoSeleccionado }}
                </v-subheader>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <template>
                  <v-file-input
                    id="docFile"
                    dense
                    filled
                    placeholder="Seleccionar archivo .docx"
                    append-icon="far fa-file-word"
                    prepend-icon=""
                    @change="onFileChange"
                    :rules="[fileRequired('documento')]"
                    :show-size="1000"
                    ref="docFile"
                    class="required"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip v-if="index < 2" small label color="primary">
                        {{ text }}
                      </v-chip>
                      <span
                        v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} archivo(s)
                      </span>
                    </template>
                  </v-file-input>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn
                  class="float-right m-1"
                  color="indigo"
                  dark
                  type="submit"
                  :loading="btnCargaDocLoading"
                  :disabled="!validFormDocumento"
                >
                  Cargar documento
                </v-btn>
                <v-btn
                  class="float-right white--text m-1"
                  color="blue-grey darken-2"
                  @click="dialogCargaDocumento = false"
                  :disabled="btnCargaDocLoading"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--fin:: dialog carga de documento -->
    <!--begin:: dialog envío expediente -->
    <!-- <v-dialog
      v-model="dialogEnviar"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Enviar a Director

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogEnviar = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea enviar al director el siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogEnviar = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(14)"
            :loading="btnEnvioAnalisis"
          >
            Sí, enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!--begin:: dialog carga de documento -->
    <v-dialog
      v-model="dialogOpinionesTecnicas"
      width="1200"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Opiniones Técnicas

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnAgregarOpinion"
            @click="dialogOpinionesTecnicas = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-1 mb-10 ml-0 mr-0">
            <v-col md="12" sm="12" class="pt-0 pb-0">
              <v-data-table
                class="elevation-0"
                :headers="headersOP"
                :loading="tableOPLoading"
                :items="opinionesTecnicas"
                :search="filtroOP"
                :footer-props="{
                  showFirstLastPage: true,
                  firstIcon: 'mdi-page-first',
                  lastIcon: 'mdi-page-last',
                  prevIcon: 'mdi-chevron-left',
                  nextIcon: 'mdi-chevron-right',
                  'items-per-page-text': 'Registros por página',
                  pageText: '{0}-{1} de {2}',
                }"
              >
                <template v-slot:top>
                  <!-- v-container, v-col and v-row are just for decoration purposes. -->
                  <v-row>
                    <v-col cols="12" md="12" sm="12" xs="12">
                      <v-text-field
                        autocomplete="off"
                        append-icon="mdi-magnify"
                        dense
                        filled
                        color="blue-grey darken-2"
                        v-model="filtroOP"
                        label="Buscar Opinión Técnica"
                        maxlength="100"
                      ></v-text-field>
                    </v-col>

                    <!--v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                          <v-btn
                            class="ma-0 white--text d-none"
                            medium
                            color="light-blue darken-2"
                          >
                            <v-icon left>mdi-magnify</v-icon> Buscar
                          </v-btn>
                        </!--v-col-->
                  </v-row>
                </template>

                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.tipo }}</td>
                    <td>{{ item.nombre }}</td>
                    <td>{{ item.fechaOficio }}</td>
                    <td>{{ item.fechaEnvio }}</td>
                    <td>
                      <v-btn
                        class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                        small
                        depressed
                        color="blue-grey lighten-5"
                        @click="descargarArchivo(item.path)"
                      >
                        <v-icon left>mdi-file-download-outline</v-icon>
                        Descargar
                      </v-btn>
                    </td>
                    <td>
                      <v-chip
                        class="ma-2 font-weight-medium"
                        label
                        :color="
                          item.obligatorio === 1
                            ? 'teal'
                            : item.obligatorio === 0
                            ? 'pink'
                            : 'pink'
                        "
                        :text-color="
                          item.obligatorio === 1
                            ? 'white'
                            : item.obligatorio === 0
                            ? 'white'
                            : 'pink darken-1'
                        "
                        small
                      >
                        {{
                          item.obligatorio === 1
                            ? "Obligatorio"
                            : "No Obligatorio"
                        }}
                      </v-chip>
                    </td>
                    <td>
                      <v-chip
                        class="ma-2 font-weight-medium"
                        label
                        :color="
                          item.estadosOpinionTecnicaId === 2
                            ? 'amber lighten-5'
                            : item.estadosOpinionTecnicaId === 3
                            ? 'teal lighten-5'
                            : 'blue lighten-5'
                        "
                        :text-color="
                          item.estadosOpinionTecnicaId === 2
                            ? 'orange'
                            : item.estadosOpinionTecnicaId === 3
                            ? 'green'
                            : 'indigo'
                        "
                        small
                      >
                        {{ item.estadoOpinionTecnica }}
                      </v-chip>
                    </td>
                    <!--<td>{{ item.usuario_Creacion }}</td>-->
                    <td>
                      <v-btn
                        v-if="item.estadosOpinionTecnicaId === 1"
                        class="ma-2 btn-bg-light white--text lighten-2--text font-weight-medium text-capitalize"
                        small
                        depressed
                        color="red accent-4"
                        @click="eliminarItem(item.id)"
                      >
                        <v-icon left>fas fa-window-close</v-icon> Eliminar
                      </v-btn>
                      <v-btn
                        v-if="item.resolucionesCount > 0"
                        class="ma-2 btn-bg-light indigo--text lighten-2--text font-weight-medium text-capitalize"
                        small
                        depressed
                        color="blue lighten-5"
                        @click="modalResolucionesOT(item.id)"
                      >
                        <v-icon left>fas fa-file-contract</v-icon> Ver
                        Resoluciones
                      </v-btn>
                      <v-btn
                        v-if="
                          item.obligatorio === 0 &&
                          item.estadosOpinionTecnicaId !== 1 &&
                          item.estadosOpinionTecnicaId !== 3
                        "
                        class="ma-2 btn-bg-light green--text lighten-2--text font-weight-medium text-capitalize"
                        small
                        depressed
                        color="teal lighten-5"
                        @click="modalFinalizarOT(item.id)"
                      >
                        <v-icon left>fas fa-check-square</v-icon> Finalizar
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--fin:: dialog carga de documento -->

    <!--begin:: dialog envío expediente -->
    <!--Dialog loader -->
    <DialogLoader
      :dialogVisible="dialogLoaderVisible"
      :text="dialogLoaderText"
      transition="scroll-y-transition"
    >
    </DialogLoader>

    <!--Dialog para mostrar la resolución de rechazo-->
    <v-dialog
      v-model="dialogResolucion"
      width="800"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Resolución de rechazo

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnRechazarExpedienteLoading"
            @click="dialogResolucion = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <div v-if="pdfUrl">
                <embed
                  :src="pdfUrl"
                  type="application/pdf"
                  width="100%"
                  height="600px"
                />
              </div>
              <div v-else>
                <p>cargando PDF...</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogResolucion = false"
            :disabled="btnRechazarExpedienteLoading"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="
              dialogResolucion = false;
              dialogFirma = true;
            "
            :disabled="btnRechazarExpedienteLoading"
          >
            Firmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogResolucionF"
      width="800"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Resolución de rechazo

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnRechazarExpedienteLoading"
            @click="dialogResolucionF = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <div v-if="pdfUrl">
                <embed
                  :src="pdfUrl"
                  type="application/pdf"
                  width="100%"
                  height="600px"
                />
              </div>
              <div v-else>
                <p>cargando PDF...</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogResolucionF = false"
            :disabled="btnRechazarExpedienteLoading"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---->
    <v-dialog
      v-model="dialogFirma"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Emitir firma

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnRechazarExpedienteLoading"
            @click="
              dialogFirma = false;
              datosFirma.pin = '';
            "
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12"> </v-col>
            <!--Cambiamos el tipo entre texto y password: type="showPin ? 'text' : 'password' "
                Para visualizar-->
            <v-text-field
              label="Ingrese su PIN"
              v-model="datosItem.pin"
              :type="showPin ? 'text' : 'password'"
              :disabled="btnRechazarExpedienteLoading"
              outlined
              append-outer-icon="mdi-eye"
              @click:append-outer="verPin"
            />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="
              dialogFirma = false;
              datosFirma.pin = '';
            "
            :disabled="btnRechazarExpedienteLoading"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            :loading="btnReschazarExpedienteLoading"
            @click="firmarResolucionR"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogNumExpediente"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Número de Expediente

          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>Número de expediente: {{ this.NoExp }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-2" text @click="salirExpediente">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
  </div>
</template>

<script>
// import ApiService from "@/core/services/api.service";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DialogLoader from "@/view/content/DialogLoader";
import SnackAlert from "@/view/content/alerts/SnackAlert.vue";
import { mapActions } from "vuex";

import validations from "@/core/untils/validations.js";
import { ACTUALIZAR_ESTADO_EXPEDIENTE_BI } from "@/core/services/store/expedientesBI/expedientesBI.module";
import {
  OBTENER_EXPEDIENTES_BY_CATEGORIA_BI,
  MOSTRARRESOLUCIONR,
  VRESOLUCION_RECHAZO,
  MODIFICAR_NO_RESOLUCION,
  GENERAR_DOC_RESOLUCION,
  FIRMAR_RESOLUCION_BI,
  MOSTRARRESOLUCIONRFIRMA,
} from "@/core/services/store/expedientesBI/expedientesBI.module";
import { OBTENER_DICTAMENES } from "@/core/services/store/dictamenes/dictamenes.module";
import {
  REGISTRAR_RESOLUCION_EXPEDIENTE,
  OBTENER_RESOLUCIONES_EXPEDIENTE,
  OBTENER_DICTAMEN_EXPEDIENTE,
  ACTUALIZAR_RESOLUCION_EXPEDIENTE,
} from "@/core/services/store/resoluciones/expedienteresolucion.module";
import { OBTENER_PATH_RESOLUCION_PLANTILLA } from "@/core/services/store/expedientes/dictamenPlantilla/resolucionPlantilla.module";
import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";
import { OBTENER_OPINIONES_TECNICAS } from "@/core/services/store/opinionesTecnicas/opinionestecnicas.module";
import JwtService from "@/core/services/jwt.service";
import { FIRMA_ELECTRONICA_BI } from "@/core/services/store/expedientes/dictamenPlantilla/firmaresolucion.module";
/*
  import {OBTENER_CONTACTOS, REGISTRAR_CONTACTO} from "@/core/services/store/contactos/contacto.module";
  import classSet from '../../../../assets/plugins/formvalidation/src/js/utils/classSet';
  */

export default {
  name: "AdminExpedientes",
  data() {
    return {
      tab: null,
      datosItem: {
        pin: "",
        user: "",
        expedienteId: 0,
        tipo: 0,
      },
      tabContactosDisabled: true,
      tableLoading: false,
      validForm: false,
      dialogEnvio: false,
      btnRechazarExpedienteLoading: false,
      btnReschazarExpedienteLoading: false,
      dialogPinFirma: false,
      btnEnvioLoading: false,
      btnRegistroContactoLoading: false,
      contactos: [],
      tableContactosLoading: false,
      ddRolesLoading: false,
      dialogRegistro: false,
      dialogLoaderVisible: false,
      dialogLoaderText: "",
      switchItemEstado: true,
      dialogNumExpediente: false,
      proyectoSeleccionado: "",
      filtro: "",
      showPin: false,
      tipoContactoSeleccionado: {},
      stepPops: {
        step: 1,
        expedienteId: 0,
        tdrRegistrados: [],
        requisitosRegistrados: [],
        tiposInstrumentoId: 0,
        categoriasId: 0,
        ocultar: false,
        estadoExpediente: 0,
        CATEGORIA: {
          CATEGORIA_C_CON_PGA: 4,
          CATEGORIA_C: 5,
          CATEGORIA_CR: 6,
        },
      },
      dialog: false,
      dialogTitle: "Registrar nuevo proyecto",
      accion: 1,
      btnRegistroText: "Guardar",
      btnRegistroLoading: false,
      estadoProyecto: "",
      items: [],
      cargos: [],
      estadosProyecto: [
        { text: "Todos", value: null },
        { value: 14, text: "Pre-Firma" },
        { value: 15, text: "Firma" },
        { value: 17, text: "Notificación" },
        { value: 18, text: "Asignación Asesores" },
        { value: 24, text: "Firma Licencia" },
        { value: 30, text: "Firma Rechazo" },
      ],
      ...validations,
      tableCLoading: false,
      itemsC: [],
      tableCRLoading: false,
      itemsCR: [],
      dialogAnalisis: false,
      btnEnvioAnalisis: false,
      datosEnvioItem: {
        id: 0,
        estadoExpedienteId: 0,
        usuario: "admin",
      },
      datosEnvioEmail: {
        id: 0,
        estadoSolicitudId: 0,
        usuario_Actualizacion: "admin",
      },
      solicitudes: [],
      filtroSolicitudes: "",
      tableSolicitudesLoading: false,
      dialogSolicitud: false,
      solicitud: {},
      dialogDictamen: false,
      validFormDictamen: false,
      btnRegistroDictamenLoading: false,
      datosItemResolucion: {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
        pathWord: "",
        tipoAprobacion: 0,
      },
      datosFirma: {
        user: "",
        pass: "",
        pin: "",
        expedienteId: "",
        tipo: 1,
      },
      notificacionFirma: {
        expedienteId: "",
        rutaFirma: "",
      },
      vFirma: false,
      dictamenes: [],
      itemsDictamen: [],
      tableDictamenLoading: false,
      ddlDictamenesLoading: false,
      dialogCrearDictamen: false,
      dialogResolucion: false,
      dialogResolucionF: false,
      pinFirma: "",
      dialogFirma: false,
      pdfUrl: null,
      btnCargaDocLoading: false,
      dialogCargaDocumento: false,
      validFormDocumento: false,
      documentoSeleccionado: "",
      archivoCargado: false,
      archivo: [],
      expedienteId: 0,
      resolucionExpedienteId: 0,
      nombrePlantilla: "",
      dialogEnviar: false,
      dialogOpinionesTecnicas: false,
      tableOPLoading: false,
      NoExp: "",
      opinionesTecnicas: [],
      filtroOP: "",
    };
  },
  watch: {
    dialogResolucion(val) {
      //Si se activó el dialogResolución, llamamos el método de obtenerPDF
      if (val) {
        this.vFirma = false;

        this.obtenerPDF();
      }
    },
    dialogResolucionF(val) {
      if (val) {
        this.vFrima = true;
        this.obtenerPDFFirma();
      }
    },
  },
  components: {
    DialogLoader,
    SnackAlert,
  },
  methods: {
    ...mapActions({
      mostrarResolucionR: MOSTRARRESOLUCIONR,
      vResolucionRechazo: VRESOLUCION_RECHAZO,
      Modificar_No_Resolucion: MODIFICAR_NO_RESOLUCION,
      generarDocResolucion: GENERAR_DOC_RESOLUCION,
      firmarResolucionRBI: FIRMAR_RESOLUCION_BI,
      mostrarResolucionRFirma: MOSTRARRESOLUCIONRFIRMA,
    }),
    async AbrirModalResolucion(expedienteId) {
      this.dialogPinFirma = true;
      this.datosItem.expedienteId = expedienteId;
    },
    required(message) {
      return (v) => !!v || message;
    },
    async ObtenerResolucionByExpediente(path) {
      let newPath = path.replace(/\\/g, "/");
      const baseUrl = process.env.VUE_APP_INTERFACE;
      window.open(baseUrl + newPath, "_blank");
    },
    async ObtenerDictamenByExpediente(path) {
      let newPath = path.replace(/\\/g, "/");
      const baseUrl = process.env.VUE_APP_INTERFACE;
      window.open(baseUrl + newPath, "_blank");
    },
    async firmaElectronica(tipo) {
      this.dialogLoaderVisible = true;
      this.datosItem.user = JwtService.getUser();
      this.datosItem.tipo = tipo;
      //this.datosItem.pin = this.datosItem.pin;
      await this.$store
        .dispatch(FIRMA_ELECTRONICA_BI, this.datosItem)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.obtenerItemsC();
            this.obtenerItemsCR();

            this.dialogDictamen = false;
            this.dialogEnviar = false;
            this.dialogFirmarResolución = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogFirmarElectronica = false;
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
        });
    },
    showFirmarExpediente(item) {
      this.dialogLoaderVisible = true;
      this.proyectoSeleccionado = item.nombreProyecto;
      this.datosEnvioItem.id = item.idExpediente;

      if (item.estadoRegistroId === 15) {
        this.dialogFirmaExpediente = true;
      } else {
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          `No es posible firmar el expediente. Verifique que este en estado Firma Resolución.`
        );
      }
      this.dialogLoaderVisible = false;
    },
    salirExpediente() {
      window.location.reload();
    },
    async firmarExpediente(estado) {
      //10 = analisis, 12 = procurador
      this.isVisible = true;
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.estadoExpedienteId = estado;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE_BI, this.datosEnvioItem)
        .then((res) => {
          if (res.status == 200) {
            // this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.dialogLoaderVisible = false;

            this.dialogFirmaExpediente = false;
            this.obtenerItemsC();
            this.obtenerItemsCR();
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    verPin() {
      this.showPin = !this.showPin;
    },
    // Obtener los items op
    async obtenerOpinionesTecnicas(id) {
      this.opinionesTecnicas = [];
      this.tableOPLoading = true;

      this.$store
        .dispatch(OBTENER_OPINIONES_TECNICAS, id)
        .then((res) => {
          if (res.status === 200) {
            this.opinionesTecnicas =
              this.$store.state.opinionestecnicas.opinionesTecnicas;
          }
          this.tableOPLoading = false;
        })
        .catch(() => {
          this.tableOPLoading = false;
        });
    },
    modalOpinionTecnica(Id) {
      this.obtenerOpinionesTecnicas(Id);
      this.dialogOpinionesTecnicas = true;
    },
    resetFormDictamen() {
      this.datosItemResolucion = {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
        tipoAprobacion: 0,
      };
    },
    agregarDictamen(id, nombreProyecto, tipo) {
      this.proyectoSeleccionado = nombreProyecto;
      this.expedienteId = id;
      this.datosItemResolucion.expedienteId = id;
      this.datosItemResolucion.tipoAprobacion = tipo;
      // this.obtenerDictamenes();
      this.dialogCrearDictamen = true;
      // this.obtenerExpedienteDictamenes(id);
      // this.datosItemResolucion.expedienteId = id;
      // this.dialogDictamen = true;
      // this.accion = 1;
    },
    //Mostrar el dialogo para la suspension
    enviarDirector(id, nombreProyecto) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;
      this.dialogEnviar = true;
      this.dialogLoaderVisible = false;
    },
    verSolicitud(id) {
      this.obtenerSolicitud(id);
    },
    filtroEstado(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.estadoProyecto.value) {
        return true;
      }
      //console.log(value);
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.estadoProyecto.text;
    },
    //Mostrar el dialogo para la suspension
    iniciarAnalisis(id, nombreProyecto, estadosExpedienteId) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;
      if (estadosExpedienteId === 14) {
        this.dialogAnalisis = true;
      } else {
        this.$router.push({
          name: "vexpedienteJefeDCABI",
          params: { id: this.datosEnvioItem.id },
        });
      }
      this.dialogLoaderVisible = false;
    },
    // Obtener los items
    async obtenerDictamenes() {
      this.dictamenes = [];
      this.ddlDictamenesLoading = true;

      this.$store
        .dispatch(OBTENER_DICTAMENES, 1)
        .then((res) => {
          if (res.status === 200) {
            this.dictamenes = this.$store.state.dictamenes.dictamenes;
          }
          //console.log(this.solicitudes);
          this.ddlDictamenesLoading = false;
        })
        .catch(() => {
          this.ddlDictamenesLoading = false;
        });
    },
    // Obtener los items expediente dictamen
    async obtenerExpedienteDictamenes(id) {
      this.itemsDictamen = [];
      this.tableDictamenLoading = true;

      this.$store
        .dispatch(OBTENER_RESOLUCIONES_EXPEDIENTE, id)
        .then((res) => {
          if (res.status === 200) {
            this.itemsDictamen =
              this.$store.state.expedienteresolucion.resolucionesExpediente;
            this.dialogDictamen = true;
            this.expedienteId = id;
            //console.log(this.expedienteId);
          }
          //console.log(this.solicitudes);
          this.tableDictamenLoading = false;
        })
        .catch(() => {
          this.tableDictamenLoading = false;
        });
    },
    obtenerDatosItem(Id) {
      this.dialogLoaderVisible = true;
      this.dialogLoaderText = "Obteniendo información...";
      this.$store
        .dispatch(OBTENER_DICTAMEN_EXPEDIENTE, Id)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.datosItemResolucion =
              this.$store.state.expedientedictamen.dictamenExpediente;
            this.accion = 2;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
          );
          this.dialogLoaderVisible = false;
        });
    },

    /// Obtener los items
    async obtenerItemsC() {
      this.itemsC = [];
      this.tableCLoading = true;

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA_BI, {
          categoriaId: 5,
          tipoBandeja: 5,
          usuario: JwtService.getUserId(),
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsC = this.$store.state.expedientesBI.expedientes_BI;
          }
          this.tableCLoading = false;
        })
        .catch(() => {
          this.tableCLoading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsCR() {
      this.itemsCR = [];
      this.tableCRLoading = true;

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA_BI, {
          categoriaId: 6,
          tipoBandeja: 5,
          usuario: JwtService.getUserId(),
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsCR = this.$store.state.expedientesBI.expedientes_BI;
          }

          this.tableCRLoading = false;
        })
        .catch(() => {
          this.tableCRLoading = false;
        });
    },
    //Enviar el expediente
    async enviarExpediente(estado) {
      //10 = analisis, 12 = procurador
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.estadoExpedienteId = estado;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE_BI, this.datosEnvioItem)
        .then((res) => {
          if (res.status == 200) {
            this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.dialogEnviar = false;
            this.dialogAnalisis = false;
            this.obtenerItemsC();
            this.obtenerItemsCR();
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    //Registro de categorias
    registrarItemDictamen() {
      this.btnRegistroLoading = true;
      this.dialogLoaderVisible = true;
      if (this.accion === 1) {
        this.$store
          .dispatch(REGISTRAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
          .then((res) => {
            this.btnLoading = false;
            if (res.status === 200) {
              this.$refs.snackalert.SnackbarShow(
                "success",
                "Mensaje",
                res.message
              );
              this.obtenerExpedienteDictamenes(
                this.datosItemResolucion.expedienteId
              );
              this.resetFormDictamen();
              // this.obtenerItemsA();
              // this.obtenerItemsB1();
              // this.obtenerItemsB2();
              this.dialogCrearDictamen = false;
            } else {
              this.$refs.snackalert.SnackbarShow(
                "warning",
                "Alerta",
                res.message
              );
            }
            this.btnRegistroLoading = false;
            this.dialogLoaderVisible = false;
          })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error durante el registro.`
            );
          });
      }
      //?Si accion es 2 se realiza la actualizacion
      else {
        this.$store
          .dispatch(ACTUALIZAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
          .then((res) => {
            if (res.status === 200) {
              this.$refs.snackalert.SnackbarShow(
                "success",
                "Mensaje",
                res.message
              );
              this.obtenerExpedienteDictamenes(
                this.datosItemResolucion.expedienteId
              );
              this.resetFormDictamen();
            } else {
              this.$refs.snackalert.SnackbarShow(
                "warning",
                "Alerta",
                res.message
              );
            }
            this.btnRegistroLoading = false;
            this.dialogLoaderVisible = false;
          })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error durante el registro.`
            );
          });
      }
    },
    async cargarArchivoWord(path) {
      this.datosItemResolucion.id = this.resolucionExpedienteId;
      this.datosItemResolucion.expedienteId = this.expedienteId;
      this.datosItemResolucion.pathWord = path;
      await this.$store
        .dispatch(ACTUALIZAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.obtenerExpedienteDictamenes(
              this.datosItemResolucion.expedienteId
            );
            this.resetFormDictamen();
            this.dialogCargaDocumento = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.mensaje
            );
          }
          //this.btnRegistroLoading = false;
          this.btnCargaDocLoading = false;
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.btnCargaDocLoading = false;
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },

    descargarPlantillaWord(Id, tipo) {
      this.dialogLoaderVisible = true;
      this.$store
        .dispatch(OBTENER_PATH_RESOLUCION_PLANTILLA, {
          expedienteId: Id,
          tipo: tipo,
        })
        .then((res) => {
          if (res.status === 200) {
            this.descargarArchivoBackend(res.message);
            this.obtenerExpedienteDictamenes(this.expedienteId);
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
          //console.log(this.items);
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
        });
    },
    descargarArchivoBackend(path) {
      let newPath = path.replace(/\\/g, "/");
      //server
      window.open("http://preprod-wsayb.marn.gob.gt" + newPath, "_blank");
      //local
      //window.open("http://10.4.1.51:8080" + newPath, "_blank");
    },
    descargarArchivo(path) {
      let newPath = path.replace(/\\/g, "/");
      //console.log(newPath);

      //SERVIDOR_PREPRODUCCION
      window.open("http://preprod-interface.marn.gob.gt" + newPath, "_blank");

      //LOCAL
      //window.open("http://10.4.1.51:8080" + newPath, "_blank");
    },
    // Tipo: 1 REquisito, 2 TDR
    mostrarModalCargaDocumento(id, nombre, tipo) {
      this.datosItemResolucion.tipoAprobacion = tipo;
      //console.log(nombre);
      if (nombre) {
        let fileNameWithoutExtension = nombre.substring(
          0,
          nombre.lastIndexOf(".")
        );
        this.nombrePlantilla = fileNameWithoutExtension;
        this.resolucionExpedienteId = id;
        this.dialogCargaDocumento = true;
      } else {
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          "Descargar plantilla."
        );
      }
    },
    onFileChange(e) {
      if (e) {
        let fileName = e.name;
        let fileNameWithoutExtension = fileName.substring(
          0,
          fileName.lastIndexOf(" ")
        );
        if (fileNameWithoutExtension === "") {
          fileNameWithoutExtension = fileName.substring(
            0,
            fileName.lastIndexOf(".")
          );
        }

        if (this.nombrePlantilla !== fileNameWithoutExtension) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El nombre del archivo no es igual al de la plantilla descargada.`
          );
          // this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }
        //this.datosRequisitoExpediente.nombreDocumento = e.name;
        //!?Validar que el tipo de archivo sea pdf
        if (
          e.type !=
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          // Api call
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El archivo que desea ingresar no es válido.`
          );
          //console.log("no es un pdf..")
          //this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }
        //?Validar que el tamaó del archivo no exceda los 10Mb
        if (e.size / 1024 / 1024 > 10) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El tamaño del archivo excede el límite permitido (10Mb)`
          );
          // this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }

        this.archivo = e;
      }
    },
    async cargarArchivo() {
      this.dialogLoaderVisible = true;
      this.btnCargaDocLoading = true;
      const files = this.archivo;
      let path = `\\resolucion\\expedientes\\${this.expedienteId}\\procurador\\`;
      //this.datosArchivo={};

      await this.$store
        .dispatch(CARGAR_ARCHIVO, { file: files, path: path })
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.archivoCargado = true;
            //this.datosRequisitoExpediente.path = res.pathArchivo;
            this.cargarArchivoWord(res.pathArchivo);

            this.$refs.docFile.reset();
            document.querySelector("#docFile").value = "";
          } else {
            this.dialogLoaderVisible = false;
            this.btnCargaDocLoading = false;
            this.archivoCargado = false;
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.mensaje
            );
            //this.btnRegistroLoading=false;
          }
        })
        .catch((error) => {
          this.$refs.snackalert("warning", "Alerta", error);
          this.dialogLoaderVisible = false;
          this.btnCargaDocLoading = false;
          this.archivoCargado = false;
        });
    },
    async obtenerPDF() {
      try {
        var id = this.datosEnvioItem.id;

        const response = await this.mostrarResolucionR(id);
        // Convertir Base64 a Blob
        // Decodifica el string Base64 a una cadena binaria
        const byteCharacters = atob(response.data);

        // Crea un array del tamaño de la cadena binaria decodificada
        const byteNumbers = new Array(byteCharacters.length);

        // Recorre la cadena binaria y convierte cada carácter en su valor numérico (código ASCII)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        // Crea un array de enteros sin signo de 8 bits a partir de los valores numéricos obtenidos
        const byteArray = new Uint8Array(byteNumbers);

        // Crea un objeto Blob que representa un archivo PDF, indicando su tipo MIME
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Crear una URL a partir del Blob y asignarla a this.pdfUrl
        this.pdfUrl = window.URL.createObjectURL(blob);
      } catch {
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          `Ha ocurrido un error durante el proceso.`
        );
      }
    },
    async obtenerPDFFirma() {
      try {
        var id = this.datosEnvioItem.id;
        const response = await this.mostrarResolucionRFirma(id);
        // Convertir Base64 a Blob
        // Decodifica el string Base64 a una cadena binaria
        const byteCharacters = atob(response.data);

        // Crea un array del tamaño de la cadena binaria decodificada
        const byteNumbers = new Array(byteCharacters.length);

        // Recorre la cadena binaria y convierte cada carácter en su valor numérico (código ASCII)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        // Crea un array de enteros sin signo de 8 bits a partir de los valores numéricos obtenidos
        const byteArray = new Uint8Array(byteNumbers);

        // Crea un objeto Blob que representa un archivo PDF, indicando su tipo MIME
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Crear una URL a partir del Blob y asignarla a this.pdfUrl
        this.pdfUrl = window.URL.createObjectURL(blob);
      } catch {
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          `Ha ocurrido un error durante el proceso.`
        );
      }
    },
    async verResolucionR(item) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = item.idExpediente;
      this.datosEnvioItem.estadoExpedienteId = 30;
      var datosF = {
        id: this.datosEnvioItem.id,
        vfirma: false,
      };
      try {
        const response = await this.vResolucionRechazo(this.datosEnvioItem);
        const respuesta = response.data;
        if (respuesta == 2) {
          //Debemos de modificar el correlativo
          const response2 = await this.Modificar_No_Resolucion(
            this.datosEnvioItem
          );
          if (response2.data === true) {
            const response3 = await this.generarDocResolucion(datosF);
            if (response3.status == 200) {
              this.dialogResolucion = true;
            }
          }
        } else {
          this.dialogResolucion = true;
        }
      } catch (error) {
        this.dialogLoaderVisible = false;
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          `Ha ocurrido un error durante el proceso.`
        );
      } finally {
        this.dialogLoaderVisible = false;
      }
    },

    async verResolucionRFirma(item) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = item.idExpediente;
      this.datosEnvioItem.estadoExpedienteId = 30;
      this.dialogResolucionF = true;
      this.dialogLoaderVisible = false;
    },
    async firmarResolucionR() {
      this.dialogFirma = false;
      this.dialogLoaderVisible = true;

      this.datosFirma.expedienteId = this.datosEnvioItem.id;
      try {
        //Generamos el reporte con fechaActual
        var datosF = {
          id: this.datosEnvioItem.id,
          vfirma: true,
        };
        const resp = await this.generarDocResolucion(datosF);
        if (resp.status == 200) {
          this.datosFirma.user = JwtService.getUser();
          const response = await this.firmarResolucionRBI(this.datosFirma);
          if (response.data === true) {
            this.dialogNumExpediente = true;
            this.NoExp = response.message;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              "Firma emitida con éxito"
            );
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              this.resultUpdateEstadoExpediente.message
            );
          }
        }
        this.dialogFirma = false;
        this.dialogLoaderVisible = false;
      } catch (error) {
        this.dialogFirma = false;
        this.dialogLoaderVisible = false;
        this.$refs.snackalert.SnackbarShow(
          "warning",
          "Alerta",
          `Ha ocurrido un error durante el proceso.`
        );
      } finally {
        this.dialogLoaderVisible = false;
      }
    },
  },
  created() {
    this.obtenerItemsC();
    this.obtenerItemsCR();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inicio", route: "/dashboard" },
      { title: "Director", route: "/administracion/expedientes/listaJefedca" },
    ]);
  },

  computed: {
    headers() {
      return [
        {
          text: "Track Id",
          align: "start",
          sortable: true,
          value: "idExpediente",
        },
        {
          text: "No. Expediente",
          align: "start",
          sortable: false,
          value: "noExpediente",
        },
        {
          text: "Nombre del proyecto",
          align: "start",
          sortable: true,
          value: "nombreProyecto",
        },
        // {
        //   text: "Descripción",
        //   align: "start",
        //   sortable: true,
        //   value: "descripcionProyecto",
        // },
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estadoExpediente",
          filter: this.filtroEstado,
        },
        {
          text: "Dictamen",
          align: "start",
          sortable: true,
          value: "tipoDictamen",
        },
        {
          text: "Acciones",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    headerDictamen() {
      return [
        {
          text: "Resolución",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Fecha Ingreso",
          align: "start",
          sortable: false,
          value: "fecha_Creacion",
        },
        {
          text: "Usuario Ingreso",
          align: "start",
          sortable: false,
          value: "usuario_Creacion",
        },
        {
          text: "Dictamen",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Plantilla Word",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Cargar Resolución",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Documento",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    headersOP() {
      return [
        {
          text: "Tipo",
          align: "start",
          sortable: false,
          value: "tipo",
        },
        {
          text: "Institución",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Fecha Oficio",
          align: "start",
          sortable: false,
          value: "fechaOficio",
        },
        {
          text: "Fecha Envío",
          align: "start",
          sortable: false,
          value: "fechaEnvio",
        },
        {
          text: "Documento",
          align: "start",
          sortable: false,
          value: "path",
        },
        {
          text: "Obligatorio",
          align: "start",
          sortable: false,
          value: "obligatorio",
        },
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estadoOpinionTecnica",
        },
        {
          text: "Acciones",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
  },
};
</script>
